export const ProductRecommendations = "0b8f65e46491e5d3f0c0fabdea11ec15f6beeb2bfab5980378916d60df33162f";